import { usageUnitTypeEnumList } from '../../../components/AgGrid/enumLists'

const usageUnitTypeValueGetter = (props) => {
  const { value } = props
  return usageUnitTypeEnumList(value)
}

export default usageUnitTypeValueGetter
